import TopeEdit from './TopeEdit';

const indexTope = {
    edit: TopeEdit,
};

export default indexTope;
